import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { AbandonedCartType } from './types'

export class AbandonedCartsService {
  static getAbandonedCarts(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AbandonedCartType[]>> {
    return apiService.get('/abandoned-carts', config)
  }
}
